import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogoutButton } from './img/LogoutButton.component'
import './sidebar.css'
import chevronSide from './img/chevronSide.svg'
import buttonOpen from './img/buttonOpen.svg'
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { getLetterName } from "./getLetterName";
import { ReactComponent as Home } from './img/home.svg'
import { ReactComponent as Plus } from './img/plus.svg'
import { ReactComponent as Control } from './img/control.svg'
import { ReactComponent as Clock } from './img/clock.svg'
import { ReactComponent as People } from './img/people.svg';
import { Icon5 } from "./img/Icon5.component"

export const SideBar = (props) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [openSide, setOpenSide] = useState(false)
    const navigate = useNavigate()
    const { accounts } = useMsal()
    const isAuthenticated = useIsAuthenticated();
    const username = isAuthenticated ? accounts[0].name : 'Sem Nome'
    const handleClick = (index) => {
        setActiveIndex(index);
    };

    const items = [
        { text: 'Home', link: '/', img: <Home />, type: false },
        // { text: 'New Data Center', link: '/dc', img: <Plus />, type: false },
        { text: 'Clients', link: '/client', img: <People />, type: false },
        { text: 'Control', link: '/control', img: <Control />, type: props.type === 'View Only' },
        { text: 'Access', link: '/menage', img: <Icon5 />, type: props.type === 'View Only' },
        { text: 'Logs', link: '/logs', img: <Clock />, type: props.type === 'View Only' },
    ];

    function logout() {
        localStorage.removeItem('access-token')
        navigate('/')
    }

    return (
        <section className="body-side-bar_container" >
            <section className={`body-side-bar ${openSide ? 'open-side-setting' : ''}`}>
                <nav className='side-bar-area'>
                    <div className='logoScala-container'>
                        <div className='logoScala-container_logo' />
                        <div
                            className={`hamburguer-icon`}
                            onClick={() => { setOpenSide(!openSide) }}
                            style={{ right: openSide ? -10 : -90 }}
                        >
                            <div className={`${openSide ? 'bar-side-open1' : 'bar1'}`} />
                            <div className={`${openSide ? 'bar-side-open2' : 'bar2'}`} />
                            <div className={`${openSide ? 'bar-side-open3' : 'bar3'}`} />
                            <img style={openSide ? { opacity: 1 } : { opacity: 0 }} src={chevronSide} className="bar4" alt="chevron-side" />
                        </div>
                        <img style={openSide ? { right: -35, transform: 'rotate(180deg)' } : { right: -30 }} onClick={() => { setOpenSide(!openSide) }} className='logoScala-container_button-open' src={buttonOpen} alt='button open' />
                    </div>
                    <hr style={{ margin: '15px 0' }} className='side-bar-area_line' />
                    <div className='side-bar-area_initials-content'>
                        <h1 className='side-bar-area_initials'>{getLetterName(username, 'letter')}</h1>
                        <div className="side-bar-area_initials-titles">
                            <h3 className="title-sidebar">{getLetterName(username)}</h3>
                            <h3 className="title-sidebar side-bar-area_initials_email">{isAuthenticated ? accounts[0]?.username : 'email@email.com'}</h3>
                        </div>
                    </div>
                    <div className="content-links-side">
                        {items.map((item, index) => {
                            if (!item.type) {
                                return (
                                    <Link key={index} className={activeIndex === index ? 'side-active content-row-side' : 'content-row-side hover-side'} onClick={() => { handleClick(index); return setOpenSide(false) }} to={item.link}>
                                        <div className={activeIndex === index ? "img-sidebar side-active-img" : "img-sidebar"}>
                                            {item.img}
                                        </div>

                                        <h3 className={"title-sidebar"}>
                                            {item.text}
                                        </h3>
                                    </Link>
                                )
                            } else {
                                return null
                            }
                        })}
                    </div>
                </nav>
                <div style={props.hiddenLogout ? { display: 'none' } : { display: 'flex' }} className='side-bar-area_logout'>
                    <hr style={{ margin: '20px 0 0 0' }} className='side-bar-area_line' />
                    <div style={{ display: openSide ? 'flex' : 'none' }}>
                        {props.children}
                    </div>
                    <div onClick={logout} className="content-row-side side-bar-area_logout_button">
                        <LogoutButton />
                        <h3 className={"title-sidebar"}>Logout</h3>
                    </div>
                </div>
            </section >
        </section >
    )
}